import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button, Popup } from "semantic-ui-react";

import { useBooleanState } from "hooks";
import DatePickerInput from "components/DatePickerInput";
import MeetingDateTypeDropdown from "components/MeetingDateTypeDropdown";

import AddNewEventPopupTrigger from "./AddNewEventPopupTrigger";

const AddNewEventPopup = ({
  title,
  pickerOpen,
  setPickerOpen,
  currentDate,
  setCurrentDate,
  loading,
  addEvent,
}) => {
  const [selectedMeetingDateType, setSelectedMeetingDateType] = useState();
  const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
  const [inputDateError, setError, clearError] = useBooleanState();

  return (
    <Popup
      on="click"
      onClose={() => {
        return setPickerOpen(false);
      }}
      open={pickerOpen}
      popperModifiers={{
        preventOverflow: {
          boundariesElement: "window",
          enabled: false,
        },
      }}
      position="bottom center"
      disabled={loading}
      data-test="add-event-popup"
      trigger={
        <AddNewEventPopupTrigger
          title={title}
          loading={loading}
          triggerOnClickHandler={() => {
            setCurrentDate(currentDate);
            setPickerOpen(true);
          }}
        />
      }
    >
      <div style={{ width: "max-content" }}>
        <MeetingDateTypeDropdown
          selectedMeetingDateType={selectedMeetingDateType}
          setSelectedMeetingDateType={setSelectedMeetingDateType}
          setIsExistingMeeting={setSaveButtonEnabled}
        />
        <DatePickerInput
          defaultDate={currentDate}
          onChange={(d) => {
            if (d) {
              setCurrentDate(d);
              clearError();
            } else {
              setError();
            }
          }}
        />
        <Button
          content="Save"
          disabled={loading || !saveButtonEnabled || inputDateError}
          fluid
          loading={loading}
          onClick={() => {
            addEvent(selectedMeetingDateType?.id);
          }}
          positive
          style={{ marginTop: "1em" }}
        />
      </div>
    </Popup>
  );
};

AddNewEventPopup.propTypes = {
  title: PropTypes.string.isRequired,
  currentDate: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  pickerOpen: PropTypes.bool.isRequired,
  addEvent: PropTypes.func.isRequired,
  setCurrentDate: PropTypes.func.isRequired,
  setPickerOpen: PropTypes.func.isRequired,
};

AddNewEventPopup.defaultProps = {
  currentDate: undefined,
};

export default AddNewEventPopup;
